module.exports = __webpack_public_path__ + "img/parkspass-logo-2023.0128b243.svg";